module.exports = __webpack_public_path__ + "img/lang.9ab8c328.svg";